// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-stepper[data-v-780644be]{background:transparent}.v-stepper[data-v-780644be]  .v-stepper__content{padding:0}", ""]);
// Exports
module.exports = exports;
